import { render } from "./ItemTypeTabGroupAccordion.vue?vue&type=template&id=bd034290"
import script from "./ItemTypeTabGroupAccordion.vue?vue&type=script&lang=js"
export * from "./ItemTypeTabGroupAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__